// extracted by mini-css-extract-plugin
export var pillWrapper = "_li-0";
export var showOverflow = "_li-1";